module.exports = __webpack_public_path__ + "static/img/IMG_20160820_185534.d0b04e45.jpg";